import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

type CreateRemoteLockUserRequest = {
  clientId: string
}

const createRemoteLockUser = async (data: CreateRemoteLockUserRequest) => {
  const response = await authAPI.post('/remote-lock/users', data)
  return response.data
}

export const useCreateRemoteLockUser = () =>
  useMutation({
    mutationFn: createRemoteLockUser,
  })
